export const AFAS_TAB_KEYS = {
    OPENSTAAND: 'openstaand',
    SYNCHRONISATIE: 'synchronisatie',
    HISTORIE: 'historie',
    CONFLICTEN: 'conflicten',
};

export const AFAS_TABS = [
    {
        key: AFAS_TAB_KEYS.OPENSTAAND,
        label: 'Openstaand',
        icon: 'openstaand',
    },
    {
        key: AFAS_TAB_KEYS.SYNCHRONISATIE,
        label: 'Synchronisatie',
        icon: 'synchronisatie',
    },
    {
        key: AFAS_TAB_KEYS.HISTORIE,
        label: 'Historie',
        icon: 'historie',
    },
    {
        key: AFAS_TAB_KEYS.CONFLICTEN,
        label: 'Conflicten',
        icon: 'conflicten',
    },
];

export const getAfasTabByKey = (tabKey) =>
    AFAS_TABS.find((tab) => tab.key === tabKey);

export const getAfasTabCount = (tabKey, tabCounts = {}) => {
    if (tabKey === AFAS_TAB_KEYS.OPENSTAAND && tabCounts.openstaand != null) {
        return tabCounts.openstaand;
    }
    if (tabKey === AFAS_TAB_KEYS.SYNCHRONISATIE && tabCounts.synchronisatie != null) {
        return tabCounts.synchronisatie;
    }
    if (tabKey === AFAS_TAB_KEYS.CONFLICTEN && tabCounts.conflicten != null) {
        return tabCounts.conflicten;
    }
    return null;
};

export const formatAfasTabLabel = (tab, tabCounts = {}) => {
    const count = getAfasTabCount(tab.key, tabCounts);
    return count != null && count > 0 ? `${tab.label} (${count})` : tab.label;
};
